import { PatHistoricoBemModel } from '@/models/patrimonio/pathistoricobem/pathistoricobem.model';
import api from '@/services/axios/api';
import { AxiosResponse } from 'axios';
import { DataSource, FiltrosModel } from '@/datasources/consulte-grid';
import TextoValor from '@/models/texto-valor';
import { RegisterOutput } from '@/models/register-output';

class PatHistoricoBemService {
 dadosIndexPaginado(
  pagina: number,
  itensPorPagina: number,
  filters: FiltrosModel[],
  patBemId: number
 ): Promise<AxiosResponse<DataSource<PatHistoricoBemModel>>> {
  return api.post<DataSource<PatHistoricoBemModel>>(
   '/PatHistoricoBem/RetornoPaginado',
   {
    rowsPerPage: itensPorPagina,
    pageNumber: pagina,
    filters,
   },
   {
    params: {
     PatBemId: patBemId,
    },
   }
  );
 }

 inserirAtualizar(model: PatHistoricoBemModel): Promise<AxiosResponse<RegisterOutput>> {
  return api.post('/PatHistoricoBem', model);
 }

 remover(id: number): Promise<AxiosResponse> {
  return api.delete('/PatHistoricoBem/' + id);
 }

 atualizar(model: PatHistoricoBemModel): Promise<AxiosResponse> {
  return api.put('/PatHistoricoBem', model);
 }

 async get(id: number): Promise<PatHistoricoBemModel> {
  const result = await api.get<PatHistoricoBemModel>(`/PatHistoricoBem/${id.toString()}`);
  return result.data;
 }

 async DropDownListTipoMovimentacao(): Promise<TextoValor[]> {
  const result = await api.get<TextoValor[]>('/PatHistoricoBem/DropDownListTipoMovimentacao');
  return result.data.map((item: any) => ({
   valor: item.valor,
   texto: item.texto,
  }));
 }
}

export default new PatHistoricoBemService();
